export const ACTIVITY = 'ACTIVITY';
export const INTERACTIVE = 'INTERACTIVE';
export const COMPONENT = 'COMPONENT';
